import { FC, Fragment, type JSX } from 'react';

import { Button, ButtonVariant } from '@/shared/ui';

import './BaseChapterTemplateStyles.scss';

interface Props {
  fields: Array<JSX.Element | null>;
  header?: JSX.Element;
  onReset: () => void;
  isDisabledSubmitAction: boolean;
}

const BaseChapterTemplate: FC<Props> = ({ fields, onReset, isDisabledSubmitAction, header = null }) => {
  return (
    <div className="base-chapter-template" data-testid="base-chapter-template">
      {header && (
        <div className="base-chapter-template__header" data-testid="base-chapter-template-header">
          {header}
        </div>
      )}
      <div className="base-chapter-template__fields" data-testid="base-chapter-template-fields">
        {fields.filter(Boolean).map((field, idx) =>
          field?.props?.layout === 'profile' ? (
            <Fragment key={field?.key || idx}>{field}</Fragment>
          ) : (
            <div key={field?.key || idx} className="base-chapter-template__field">
              {field}
            </div>
          ),
        )}
      </div>
      <div className="base-chapter-template__actions" data-testid="base-chapter-template-actions">
        {isDisabledSubmitAction && (
          <div className="base-chapter-template__action">
            <Button onClick={onReset} key="cancel" variant={ButtonVariant.SECONDARY}>
              Скасувати
            </Button>
          </div>
        )}
        <div className="base-chapter-template__action">
          <Button disabled={!isDisabledSubmitAction} key="save" type="submit" variant={ButtonVariant.PRIMARY}>
            Зберегти
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BaseChapterTemplate;
